export default (builder) =>
  builder.query({
    query: ({ topicId }) => ({
      url: `report-summary-topics/${topicId}`,
      method: 'GET',
    }),
    providesTags: ['report-summary-topics'],
  });
